import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function ApplicationForm() {
  return <div className="min-h-screen bg-white flex flex-col font-sans" data-id="element-585">
      <Navigation data-id="element-586" />

      <main className="flex-grow py-12 px-4 sm:px-6 lg:px-8 mt-20" data-id="element-587">
        <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200" data-id="element-588">
          <div className="bg-gray-50 border-b border-gray-200 p-8 text-center" data-id="element-589">
            <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-590">
              Business Funding Application
            </h1>
            <p className="text-gray-600" data-id="element-591">
              Complete this form to get funding options within 24-48 hours
            </p>
          </div>

          <div className="w-full" data-id="element-592">
            <iframe src="https://dashboard.b2systems.io/apps/UFs1gT7hJQZ8A9zk85dFemX1VqV2" className="w-full border-0" style={{
            minHeight: '800px'
          }} allow="forms" sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation" title="Business Funding Application" data-id="element-593" />
          </div>
        </div>
      </main>

      <Footer data-id="element-594" />
    </div>;
}